import { render, staticRenderFns } from "./HealthPlans.vue?vue&type=template&id=4a4a3ad2&scoped=true&"
import script from "./HealthPlans.vue?vue&type=script&lang=js&"
export * from "./HealthPlans.vue?vue&type=script&lang=js&"
import style0 from "./HealthPlans.vue?vue&type=style&index=0&id=4a4a3ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4a3ad2",
  null
  
)

export default component.exports